import { useSyncExternalStore } from 'react';
import type { Session } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

/**
 * Sesja jako magazyn modułowy — JEDNA subskrypcja na stronę, nie jedna na komponent.
 *
 * Powstało dla serduszek (lista renderuje kilkadziesiąt kart naraz), ale teraz potrzebuje
 * tego też strona oferty: od DEC-04 część kolumn `flat.offers` jest dla zalogowanych, więc
 * lista kolumn w zapytaniu ZALEŻY od tego, kto pyta. Stąd osobny plik zamiast trzymania tego
 * w środku ulubionych — to nie jest sprawa ulubionych.
 *
 * `undefined` znaczy „jeszcze nie wiemy", a nie „niezalogowany". Różnica jest istotna wszędzie,
 * gdzie od tego zależy zapytanie: strzał przed czasem poszedłby z listą kolumn dla anona i
 * trzeba by go powtarzać.
 */
let sesja: Session | null = null;
let znamySesje = false;
let wystartowano = false;
const sluchacze = new Set<() => void>();

const powiadom = () => { for (const s of sluchacze) s(); };

function wystartuj() {
  if (wystartowano) return;
  wystartowano = true;
  supabase.auth.getSession().then(({ data }) => {
    sesja = data.session;
    znamySesje = true;
    powiadom();
  });
  supabase.auth.onAuthStateChange((_zdarzenie, nowa) => {
    sesja = nowa;
    znamySesje = true;
    powiadom();
  });
}

function subskrybuj(cb: () => void) {
  wystartuj();
  sluchacze.add(cb);
  return () => { sluchacze.delete(cb); };
}

function migawka(): Session | null | undefined {
  return znamySesje ? sesja : undefined;
}

export function useSesja(): Session | null | undefined {
  return useSyncExternalStore(subskrybuj, migawka, () => undefined);
}
